import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import CheckRounded from '@mui/icons-material/CheckRounded';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { useUntypedTranslation } from '../../../hooks/useUntypedTranslation';
import { AdvisoryEvidenceText, AdvisoryEvidenceValue } from './AdvisoryInlineEvidence';

export function AdvisoryRecommendationValue({ value }: { value: string | null | undefined }) {
  const { t } = useUntypedTranslation();
  const normalized = (value ?? '').trim().toLowerCase();
  if (normalized !== 'true' && normalized !== 'false') {
    return <AdvisoryEvidenceValue>{value}</AdvisoryEvidenceValue>;
  }

  const recommended = normalized === 'true';
  const label = t(recommended ? 'advisory:brief.recommended' : 'advisory:brief.notRecommended');
  const Icon = recommended ? CheckRounded : CloseRounded;

  return (
    <AdvisoryEvidenceText
      renderText={text =>
        text.trim() ? (
          <Box
            key="recommendation"
            component="span"
            role="img"
            aria-label={label}
            title={label}
            sx={theme => ({
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              verticalAlign: 'middle',
              padding: '4px 12px',
              borderRadius: theme.visualPrimitives.radiusPill,
              color: recommended ? theme.palette.success.main : theme.palette.error.main,
              backgroundColor: alpha(
                recommended ? theme.palette.success.main : theme.palette.error.main,
                0.08
              ),
            })}
          >
            <Icon sx={{ fontSize: 20 }} />
          </Box>
        ) : (
          text
        )
      }
    >
      {value}
    </AdvisoryEvidenceText>
  );
}
